import * as cx from 'classnames';
import * as React from 'react';
import * as Styles from './Column.scss';

interface IOwnProps {
  small?: boolean;
}

const Column: React.SFC<IOwnProps> = ({ children, small }) => {
  const columnClassNames = cx({
    [Styles.column]: true,
    [Styles.small]: small,
  });

  return <div className={columnClassNames}>{children}</div>;
};

export default Column;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/presentational/Column/Column.tsx